import { gql } from '@apollo/client';
import COMPONENT_COLORS_AND_SIZES from '../fragments/COMPONENT_COLORS_AND_SIZES';
const SET_COMPONENT_HAS_ONE_VARIANT_COLOR_FOR_ALL_SPECIFICATION_COLORS = gql `
  ${COMPONENT_COLORS_AND_SIZES}
  mutation ToggleVariedOnColor(
    $componentId: ID!
    $hasOneVariantColorForAllSpecificationColors: Boolean!
  ) {
    setComponentHasOneVariantColorForAllSpecificationColors(
      componentId: $componentId
      hasOneVariantColorForAllSpecificationColors: $hasOneVariantColorForAllSpecificationColors
    ) {
      component {
        id
        hasOneVariantColorForAllSpecificationColors
        variantColorForAllSpecificationColors
        ...ComponentColorsAndSizesFragment
      }
    }
  }
`;
export default SET_COMPONENT_HAS_ONE_VARIANT_COLOR_FOR_ALL_SPECIFICATION_COLORS;
